import styled from 'styled-components'

import { PreviewContent as BasePreviewContent } from '../previewStyles'

export { Container } from '../previewStyles'

export const PreviewContent = styled(BasePreviewContent)`
  background-color: ${props => props.theme.colors.background.secondary};

  p {
    margin: 0;
  }
`
